
import { useForm } from "react-hook-form";
import OutlinedInput from "@mui/material/OutlinedInput";
import { FormControl, InputLabel, Select, MenuItem, Tooltip, ListItemText, Button, Checkbox } from '@mui/material'
import React, { useState, useEffect, useRef } from 'react'
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "../../../../utils/fvAxios";
import BaseURL from "../../../../utils/base-uri.json";
import { getGlobalClientId, getToken, getOrgType, getOrgId, setOrgType } from "../../../../utils/Token";
import useFetch from "../../../../utils/useFetch";


export default function ReportLuckStone({ close, name }) {
  const [location, setLocation] = React.useState([]);
  const { data: resps } = useFetch(
    "Vendor/GetLocationsByClientId?clientId=" + getOrgId()
  );
  useEffect(() => {
    if (resps?.data) {
      setLocation(resps?.data?.filter(location => location.key !== "-1"))

      console.log(location);
    }
  }, [resps]);
  const [selectedlocation, setSelectedLocation] = useState([]);
  const [token, setToken] = useState(getToken())




  const handleDocTypeChange2 = (event) => {
    setSelectedLocation(event.target.value);
  };
  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };

  const [selectedDocs, setSelectedDocs] = useState([]);

  const handleDocTypeChange = (event) => {
    setSelectedDocs(event.target.value);
  };

  const menuListRef = useRef(null);
  const handleMenuOpen = () => {
    scrollToTopOfOtions();
  };
  const scrollToTopOfOtions = () => {
    setTimeout(() => {
      if (menuListRef.current) {
        const children = menuListRef.current.children;
        if (children.length >= 2) {
          const secondLastOption = children[children.length - 2];
          if (secondLastOption) {
            secondLastOption.scrollTop = 0;
          }
        }
      }
    }, 5);
  };
  return (
    <>
      <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
      <DialogContent>
        <form
          action={
            BaseURL?.baseReportUrl + "LuckStoneVendorPQDetails.aspx"
          }
          method="post"
          target="_blank"
        >
          <div style={{ marginLeft: "25px" }}>




            <FormControl>
              <Select
                labelId="docs-label"
                id="docs-select"
                multiple
                size='small'
                sx={{ width: "340px", overflow: "hidden" }}
                name="clientSites"
                value={selectedDocs}
                onChange={handleDocTypeChange}
                MenuProps={{
                  ref: menuListRef,
                  PaperProps: MenuProps.PaperProps,
                }
                }
                renderValue={(selected) =>
                  selected
                    .map((value) => location?.find((doc) => doc?.key === value)?.value)
                    .filter((value) => value !== undefined)
                    .join(", ")
                }
                inputProps={{ 'aria-label': 'Select Documents' }}
              >
                <MenuItem key="Select All">

                  <Checkbox
                    id="select-all-checkbox"
                    indeterminate={
                      selectedDocs?.length > 0 && selectedDocs?.length < location?.length
                    }
                    checked={selectedDocs?.length === location?.length}
                    onChange={(event) => {
                      if (event?.target?.checked) {
                        setSelectedDocs(location?.map((doc) => doc?.key));
                        scrollToTopOfOtions();
                      } else {
                        setSelectedDocs([]);
                      }
                    }}
                  />
                  <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                    Select All
                  </label>
                </MenuItem>
                {location?.map((doc) => (
                  <MenuItem key={doc?.key} value={doc?.key} title={doc?.value}>
                    <Checkbox checked={selectedDocs?.indexOf(doc?.key) > -1} />
                    <ListItemText primary={doc?.value} sx={{ overflowX: "hidden" }} />
                  </MenuItem>
                ))}
              </Select>

            </FormControl>

            {/* <input type="text" name="roleName"  value={setOrgType()} hidden="true"/> */}
            <input type="text" name="clientID" value={getOrgId()} hidden="true" />
          </div>
          <DialogActions>
            <div className="login-help__buttonContainer">
              <Button
                variant="contained"
                className="login-help-button-cancel"
                onClick={close}
              >
                {" "}
                Cancel
              </Button>

              {selectedDocs == "" ? (
                <Tooltip title="All the fields are mandatory" followCursor>
                  <span>
                    <Button
                      variant="contained"
                      className="login-button-request"
                      onClick={close}
                      disabled={
                        selectedDocs == ""
                      }
                    >
                      Create Report
                    </Button>
                  </span>
                </Tooltip>
              ) : (
                <Button
                  variant="contained"
                  type="submit"
                  className="login-button-request"
                  onClick={close}
                >
                  Create Report
                </Button>
              )}
            </div>
          </DialogActions>
          <input type="hidden" name="token" value={token} />
        </form>

        <br />
      </DialogContent>

    </>
  )
}
